/**
 * @generated SignedSource<<b3001e4ed85c8e222e36fdc5a81c1f9b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuySharedPersonalizedSearchItems_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedRelatedItemsSection_user">;
  readonly " $fragmentType": "BuySharedPersonalizedSearchItems_user";
};
export type BuySharedPersonalizedSearchItems_user$key = {
  readonly " $data"?: BuySharedPersonalizedSearchItems_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuySharedPersonalizedSearchItems_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedPersonalizedSearchItems_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRelatedItemsSection_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b206a0d761283cbbcc3f5c8ce7aaf377";

export default node;
